import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/provide/common.service';

@Component({
  selector: 'service-card',
  templateUrl: './service-card.component.html',
  styleUrls: ['./service-card.component.scss']
})
export class ServiceCardComponent implements OnInit {
  @Input() data : any
  @Input() catName : any
  @Input() desc : any
  @Output() on_Click = new EventEmitter
  @Output() on_Click_Cat = new EventEmitter
  isLoaded: boolean = false;
  constructor(private commonService:CommonService) { }

  ngOnInit(): void {
  }
  navigateToViewProduct(e){
    this.on_Click.emit(e)
  }
  // navigateTocategory(e,data){
  //   this.on_Click_Cat.emit({
  //     e:e,data:data
  //   })
  // }
  onImageLoad(){
    this.isLoaded = true
  }
  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
  toFixed(number, toLength: number) {
    return Number(number).toFixed(toLength)
  }
}
